'use strict';

const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const NonReentrantCommand=require('../../../dist-es6/client/angularCommon/nonReentrantCommand');
const ModalSubmissionCommand=require('../../../dist-es6/client/angularCommon/modalSubmissionCommand');let

UiCommandFactory=class UiCommandFactory extends BaseService{
static get $inject(){
return['$timeout','rx'];
}

constructor($timeout,rx){
super();
this._$timeout=$timeout;
this._rx=rx;
}

make(asyncAction){
return new NonReentrantCommand(asyncAction,this._$timeout,this._rx);
}

makeForModal(modalInstance,asyncSucceedOrFailFunc){
return new ModalSubmissionCommand(modalInstance,asyncSucceedOrFailFunc,this._$timeout,this._rx);
}};


module.exports=UiCommandFactory;
//# sourceMappingURL=uiCommandFactory.js.map
